/*
 * Enlaces de Orvian Meet dentro de eventos del calendario (ubicación o descripción). Lo usan el Calendario del
 * portal (editor, detalle, tarjeta de invitación) y la portada de Meet (reuniones del día). Sin dependencias pesadas.
 */
import { MEET_URL } from './dominios';

const BASE = (MEET_URL || 'https://meet.orvian.mx').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const RE = new RegExp(`${BASE}/([a-z]{3}-[a-z]{4}-[a-z]{3})`, 'i');

/** Primer enlace de Meet en los textos dados → {url, codigo} o null. */
export function enlaceMeet(...textos) {
  for (const t of textos) {
    const m = RE.exec(String(t || ''));
    if (m) return { url: `${MEET_URL || 'https://meet.orvian.mx'}/${m[1].toLowerCase()}`, codigo: m[1].toLowerCase() };
  }
  return null;
}
